import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { ActivePage, ILayoutProps } from '../app-layout/AppLayout';
import { AppLayoutDetailHeaderIntent } from '../common/props';
import { HeaderPlacementEnum } from '../app/AppLayout';
import { AppLayoutWaitForQueryData } from '../app/AppLayoutWaitForQueryData';

export interface IDetailPageProps extends ILayoutProps {
  /**
   * Maximální šířka obsahu stránky, standardně 1600, dá se obecně vypnout pomocí noDefaultContentWidth nebo případně nastavit na jonou hodnotu.
   */
  contentWidth?: number;
  /**
   * Pokud je zapnuto, tak se nepoužije výchozí šířka obsahu stránky a je obsah zobrazen na celou šířku.
   */
  noDefaultContentWidth?: boolean;
  /**
   * Hlavička detail stránky.
   */
  header: React.ReactNode;
  /**
   * Umístění hlavičky detail stránky, výchozí je `HeaderPlacementEnum.TOP`, tedy nad obsahem stránky.
   */
  headerPlacement?: HeaderPlacementEnum;
  /**
   * Intent hlavičky detail stránky, výchozí je `default`.
   */
  headerIntent?: AppLayoutDetailHeaderIntent;
  /**
   * Pokud je true, tak se nepřidává padding kolem obsahu stránky. Výchozí padding je 3x šířka, tedy 21px.
   */
  noPadding?: boolean;
  /**
   * Pokud je true, tak se nepřidává scroll na detail stránk.
   */
  noScroll?: boolean;
}

export type DetailPageProps = IDetailPageProps;

export const pageDefaultContentWidth = 1600;

export const DetailPage: React.FC<DetailPageProps> = ({
  children,
  className,
  queries,
  contentWrapperClassName,
  noDefaultContentWidth,
  header,
  headerIntent,
  contentWidth = pageDefaultContentWidth,
  headerPlacement = HeaderPlacementEnum.TOP,
  currentPage,
  noPadding,
  noScroll,
}) => {
  let cls = classNames(Classes.DETAIL_PAGE_LAYOUT, className, {
    [Classes.DETAIL_PAGE_HEADER_TOP]:
      headerPlacement === HeaderPlacementEnum.TOP,
    [Classes.DETAIL_PAGE_HEADER_LEFT]:
      headerPlacement === HeaderPlacementEnum.LEFT,
  });
  let detailHeaderCls = classNames(Classes.DETAIL_PAGE_HEADER, {
    [Classes.DETAIL_PAGE_HEADER_DEFAULT]:
      !headerIntent || headerIntent === 'default',
    [Classes.DETAIL_PAGE_HEADER_SECONDARY]: headerIntent === 'secondary',
  });
  const contentWrapperCls = classNames(
    Classes.DETAIL_PAGE_CONTENT_WRAPPER,
    { [Classes.DETAIL_PAGE_CONTENT_PADDING]: !noPadding },
    contentWrapperClassName
  );
  return (
    <div className={cls}>
      <ActivePage currentPage={currentPage} />
      <AppLayoutWaitForQueryData queries={queries ?? []}>
        {() => (
          <>
            <div className={detailHeaderCls}>{header}</div>
            <div
              className={classNames(Classes.DETAIL_PAGE_CONTENT_SC_WRAPPER, {
                [Classes.DETAIL_PAGE_CONTENT_NOSCROLL]: noScroll,
              })}
            >
              <div
                className={contentWrapperCls}
                style={{
                  maxWidth: noDefaultContentWidth ? undefined : contentWidth,
                }}
              >
                {typeof children === 'function' ? children() : children}
              </div>
            </div>
          </>
        )}
      </AppLayoutWaitForQueryData>
    </div>
  );
};
